// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"we-z","summaryPar":"xe-z","ratingCategories":"ye-z","reviewerInfo":"ze-z","reviewTypes":"Ae-z","expanded":"Be-z"};